import type { ReactNode } from 'react';

export const symbol_mail_asterisk: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-480Zm0-47 340-213H140l340 213ZM140-160q-24 0-42-18.5T80-220v-520q0-23 18-41.5t42-18.5h680q23 0 41.5 18.5T880-740v316q0 13-8.5 21.5T850-394q-13 0-21.5-8.5T820-424v-256L512-484q-15 10-32 10t-32-10L140-680v460h377q13 0 21 8.5t8 21.5q0 13-8.5 21.5T516-160H140Zm620 30-34 59q-6 11-18 14t-23-3q-11-6-14-18t3-23l34-59h-68q-13 0-21.5-8.5T610-190q0-13 8.5-21.5T640-220h68l-34-59q-6-11-3-23t14-18q11-6 23-3t18 14l34 59 34-59q6-11 18-14t23 3q11 6 14 18t-3 23l-34 59h68q13 0 21.5 8.5T910-190q0 13-8.5 21.5T880-160h-68l34 59q6 11 3 23t-14 18q-11 6-23 3t-18-14l-34-59Z"
		/>
	</svg>
);
